import { IAuth } from "@kunduz/data-access-auth-api";
import { getCookie } from "cookies-next";
import { useEffect } from "react";
import { getContentGroup } from "../utils/getContentGroup";

export const useGtagMiddleware = (
  profiles?: IAuth.IVerifyOtpResponse["profiles"],
) => {
  useEffect(() => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const originalPush = window.dataLayer.push;

    const middleware = (originalData) => {
      const user_id = profiles?.id || getCookie("kz_user_id");
      const content_group = getContentGroup(window.location.pathname);

      return {
        ...originalData,
        user_id,
        platform: "WEB",
        content_group,
      };
    };

    window.dataLayer.push = function (...args) {
      const manipulatedData = middleware(args[0]);

      return originalPush.call(window.dataLayer, manipulatedData);
    };

    return () => {
      window.dataLayer.push = originalPush;
    };
  }, [profiles]);
};
